import api from '../../Axios'; // Adjust path to your Axios instance

// 🟢 STEP 4: Save Medical Registration Proof
// Endpoint: /api/experts/doctor/registration
export const saveMedicalRegistration = async (formData: FormData) => {
  return api.post('/api/experts/doctor/registration', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};